module.exports = __webpack_public_path__ + "static/media/IMG_0031.4539f114.JPG";